import React, { useState } from 'react';
import { Typography, Box, Button, Switch, FormControlLabel } from '@mui/material';
import ActivityLayout from '../ActivityLayout';

function IdentifyShapes({ onBack, onCorrect, initialTimer = null, globalTimer = null, onGlobalTimeUp, score }) {
  const shapes = [
    { name: 'Rond', symbol: '⭕', buttonEmoji: '🔴' },
    { name: 'Coeur', symbol: '❤️', buttonEmoji: '💝' },
    { name: 'Triangle', symbol: '🔺', buttonEmoji: '📐' },
    { name: 'Carré', symbol: '⬛', buttonEmoji: '🟥' },
    { name: 'Étoile', symbol: '⭐', buttonEmoji: '🌟' },
  ];

  const [currentShape, setCurrentShape] = useState(generateShape());
  const [emoji, setEmoji] = useState(null);
  const [showNext, setShowNext] = useState(false);
  const [babyMode, setBabyMode] = useState(false);

  function generateShape() {
    return shapes[Math.floor(Math.random() * shapes.length)];
  }

  const handleAnswer = (answer) => {
    //if (showNext) return;
    
    const correct = answer === currentShape.name;
    setEmoji(correct ? '🎉' : '❌');
    setShowNext(true);

    if (correct) {
      onCorrect();
    }
  };

  const handleNext = () => {
    setCurrentShape(generateShape());
    setEmoji(null);
    setShowNext(false);
  };

  const toggleBabyMode = () => {
    setBabyMode(!babyMode);
  };

 

  return (
    <ActivityLayout 
      onBack={onBack}
      timeLimit={initialTimer}
      globalTimeLimit={globalTimer}
      onTimeUp={() => {
        setEmoji('⏰');
        setShowNext(true);
      }}
      onGlobalTimeUp={onGlobalTimeUp}
      isPaused={showNext}
      score={score}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 600,
          width: '100%'
        }}>
          <Typography variant="h5" align="center">
            Quel est le nom de cette forme ?
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
            <Typography variant="h1">{currentShape.symbol}</Typography>
          </Box>

          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            gap: 2, 
            flexWrap: 'wrap',
            width: '100%'
          }}>
            {shapes.map((shape) => (
              <Button
                key={shape.name}
                onClick={() => handleAnswer(shape.name)}
                variant="outlined"
                sx={{ 
                  width: 100, 
                  height: 30,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.6rem',
                  gap: 1
                }}
                disabled={showNext}
              >
                {shape.name}  {babyMode && shape.buttonEmoji}
              </Button>
            ))}
          </Box>

          {emoji && (
            <Box
              onClick={handleNext}
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                cursor: 'pointer',
              }}
            >
              <Typography variant="h1">{emoji}</Typography>
            </Box>
          )}

          {showNext && (
            <Typography align="center" sx={{ mt: 2 }}>
              Cliquez n'importe où pour continuer
            </Typography>
          )}

          <Box mt={3}>
            <FormControlLabel
              control={<Switch checked={babyMode} onChange={toggleBabyMode} />}
              label="Mode Bébé"
            />
          </Box>
        </Box>
      </Box>
    </ActivityLayout>
  );
}

export default IdentifyShapes;
